import { FormDialog, OutlinedInput } from '@aibees/shared/components';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Wrapper = styled(Box)``;

export const Dialog = styled(FormDialog)``;

export const PopoverInput = styled(OutlinedInput)``;
